/** @jsxRuntime classic */
/** @jsx jsx */

// eslint-disable-next-line no-unused-vars
import React from 'react'
import { Link as BaseLink } from 'gatsby'
import { jsx } from 'theme-ui'

const Link = (props) => <BaseLink {...props} />

export default Link
